import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../OneModal/OneModal'
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import { Message } from '@mui/icons-material'
import OneTextArea from '../OneTextArea/OneTextArea'
import OneSelect from '../OneSelect/OneSelect'
import { useContext, useEffect, useState } from 'react'
import { VisitantesContext } from '../../Providers/VisitantesContext/VisitantesContext'
import { UserContext } from '../../Providers/UserContext/UserContex'
import { showNotify } from '../../Utils/Utils'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import OneButton from '../OneButton/OneButton'

const EnviarMsgModal = ({ openEnviarMsg, setOpenEnviarMsg, pessoa }) => {
    const { buscarMsgApp, enviarMsgApp } = useContext(VisitantesContext)
    const { addRoute } = useContext(WebSocketContext)
    const { user } = useContext(UserContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        buscarMsgApp(pessoa.CD_ACESSO)
    }, [])

    const [mensagens, setMensagens] = useState([])
    const [mensagemPersonalizada, setMensagemPersonalizada] = useState(false)
    const [mensagemEnvio, setMensagemEnvio] = useState('')
    const [todosImovel, setTodosImovel] = useState(0)

    const receiveMsgApp = (msg) => {
        if (msg.data.status !== 'error') {
            if (msg.data.dados.lista_mensagens.length == 0 && msg.data.dados.msg_personalizada == false && msg.data.dados.usa_app == false) {
                showNotify('warning', 'Usuário não utiliza APP!')
                setOpenEnviarMsg(false)
            } else {
                setMensagens(msg.data.dados.lista_mensagens)
                setMensagemPersonalizada(msg.data.dados.msg_personalizada)
                setLoading(false)
            }
        } else {
            showNotify('error', msg.message)
            setOpenEnviarMsg(false)
        }
    }

    addRoute('listaMensagensApp', receiveMsgApp)
    addRoute('enviaMensagemApp', (msg) => {
        if (msg.data.status !== 'error') {
            showNotify('success', 'Mensagem enviada com sucesso!')
            setOpenEnviarMsg(false)
        } else {
            showNotify('error', msg.message)
        }
    })

    return (
        <OneModal
            open={openEnviarMsg}
            setOpen={setOpenEnviarMsg}
            titleText="Enviar Mensagem"
            TitleIcon={ Message }
            fullWidth={true}
            maxWidth="sm"
        >
            {!loading
                ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography component="div">
                        Título:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OneSelect
                                options={mensagens}
                                valor="texto"
                                label='nome'
                                onChange={(e) => { setMensagemEnvio(e.target.value) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography component="div">
                        Mensagem:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OneTextArea
                                newSx={{
                                    height: '150px',
                                    borderRadius: '5px'
                                }}
                                fontSize='16px'
                                placeholder="Digite sua mensagem aqui..."
                                rows={6}
                                value={mensagemEnvio}
                                onChange={(e) => { setMensagemEnvio(e.target.value) }}
                                disabled={mensagemPersonalizada}
                            />
                        </Grid>
                        <Grid>
                            <FormGroup>
                                <FormControlLabel control={
                                    <Checkbox
                                        defaultChecked={todosImovel}
                                        onChange={(e) => { setTodosImovel(e.target.value == 'on' ? 1 : 0) }}
                                    />}
                                label="Enviar para todos do imóvel"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid item container gap={2} m={2} xs={12}>
                            <Grid item container gap={2} marginBottom={1} justifyContent="flex-end" xs={12}>
                                <OneButton
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                        let idImovel = (todosImovel == 1 ? pessoa.ID_IMOVEL : 0) // Se for para todos do imovel, alimenta filtro do id_imovel

                                        enviarMsgApp(pessoa.CD_ACESSO, mensagemEnvio, user.nome, 0, idImovel)
                                    }}
                                >Enviar Mensagem</OneButton>
                                <OneButton
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                        setOpenEnviarMsg(false)
                                    }}
                                >Cancelar</OneButton>
                            </Grid>
                        </Grid>
                    </Grid>)
                : (
                    <Typography sx={{ display: 'flex', justifyContent: 'center' }}>
                    Carregando...
                    </Typography>
                )}
        </OneModal>
    )
}

export default EnviarMsgModal
